import { Slot } from '@radix-ui/react-slot';
import { cva } from 'class-variance-authority';
import * as React from 'react';

import { cn } from '@/lib/utils';

const buttonVariants = cva(
  'inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-bold ring-offset-background transition-all duration-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#d62828] focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 cursor-pointer',
  {
    variants: {
      variant: {
        default:
          'bg-[#1a1a1a] text-[#fefcf6] border-2 border-[#1a1a1a] shadow-[3px_3px_0px_#1a1a1a] hover:translate-x-[-1px] hover:translate-y-[-1px] hover:shadow-[4px_4px_0px_#1a1a1a] active:translate-x-[2px] active:translate-y-[2px] active:shadow-none',
        destructive:
          'bg-[#d62828] text-[#fefcf6] border-2 border-[#1a1a1a] shadow-[3px_3px_0px_#1a1a1a] hover:translate-x-[-1px] hover:translate-y-[-1px] hover:shadow-[4px_4px_0px_#1a1a1a] active:translate-x-[2px] active:translate-y-[2px] active:shadow-none',
        outline:
          'border-2 border-[#1a1a1a] bg-transparent text-[#1a1a1a] hover:bg-[#ede5d4] shadow-[3px_3px_0px_#1a1a1a] hover:translate-x-[-1px] hover:translate-y-[-1px] hover:shadow-[4px_4px_0px_#1a1a1a] active:translate-x-[2px] active:translate-y-[2px] active:shadow-none',
        secondary:
          'bg-[#fcbf49] text-[#1a1a1a] border-2 border-[#1a1a1a] shadow-[3px_3px_0px_#1a1a1a] hover:translate-x-[-1px] hover:translate-y-[-1px] hover:shadow-[4px_4px_0px_#1a1a1a] active:translate-x-[2px] active:translate-y-[2px] active:shadow-none',
        ghost:
          'hover:bg-[#ede5d4] text-[#1a1a1a] border-2 border-transparent hover:border-dashed hover:border-[#1a1a1a]',
        link: 'text-[#d62828] underline-offset-4 hover:underline decoration-wavy decoration-2',
      },
      size: {
        default: 'h-10 px-5 py-2',
        sm: 'h-9 px-4',
        lg: 'h-12 px-8 text-base',
        icon: 'h-10 w-10',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  }
);

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : 'button';
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      style={{ fontFamily: "'Patrick Hand', cursive", borderRadius: 0 }}
      ref={ref}
      {...props}
    />
  );
});
Button.displayName = 'Button';

export { Button, buttonVariants };
export default Button;
